import { render, staticRenderFns } from "./expenseMasterView.vue?vue&type=template&id=5b2a24f0&"
import script from "./expenseMasterView.vue?vue&type=script&lang=js&"
export * from "./expenseMasterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports